import Box from "@material-ui/core/Box";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";
import { Color, stickyButtonBarHeight } from "../../theme";
import { HasChildren, HasTestId, PlainFunctionComponent } from "../../types";

export interface StickyButtonBarProps extends HasChildren, HasTestId {
    className?: string;
}

export const StickyButtonBar: PlainFunctionComponent<StickyButtonBarProps> = ({ className, children, testId }) => {
    const classes = useStyles();
    return (
        <Box className={clsx(classes.stickyButtonBar, className)} height={stickyButtonBarHeight} data-testid={testId}>
            {children}
        </Box>
    );
};

const useStyles = makeStyles(
    createStyles({
        stickyButtonBar: {
            backgroundColor: Color.white,
            borderTop: "1px solid",
            borderTopColor: Color.grey3,
            bottom: "0",
            paddingRight: "24px",
            position: "fixed",
            width: "100%",
            zIndex: 500, // zIndex needs to be 1300 or smaller otherwise it won't be displayed behind a popup backdrop -- 500 is sufficient though.
            "& > *": {
                margin: "16px 0 16px 24px",
            },
        },
    }),
);
